export default {
    // domain: "https://skynz-dev.au.auth0.com",
    // clientId: "KoLJbbkYcgU0t37vN6mTAt0mxfBOdHkS",
    domain: process.env.REACT_APP_AUTH0_DOMAIN!,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
    scope:
      "openid profile email https://idm.sky.co.nz/profile_id https://idm.sky.co.nz/account_id https://idm.sky.co.nz/email_address https://idm.sky.co.nz/customer_group_type",
    audience: "https://api.sky.co.nz",
  };
  